<div class="center  popup-container">
  <mat-icon *ngIf="!data.spinner">sensors_off</mat-icon>
  <mat-spinner *ngIf="data.spinner"></mat-spinner>
  <h2>{{data.title | async}}</h2>
  <button mat-raised-button (click)="openDialog()" *ngIf="!data.spinner">{{ 'dialog.reload' | translate }}</button>
</div>
